module.exports = __webpack_public_path__ + "img/custom-10.4cfbce24.svg";